<script>
  import LayeredView from "../LayeredView.svelte";
  import ViewHeader from "../ViewHeader.svelte";
  import { createEventDispatcher, onDestroy } from "svelte";

  export let item = null;
  export let visible = false;

  const dispatch = createEventDispatcher();

  let mediaUrl = null;

  $: if (item && item.blob) {
    if (mediaUrl) URL.revokeObjectURL(mediaUrl);
    mediaUrl = URL.createObjectURL(item.blob);
  }

  function close() {
    dispatch("close");
  }

  async function shareOrSave() {
    if (!item || !item.blob) return;
    const extension = item.type.includes("video") ? "mp4" : "jpg";
    const file = new File([item.blob], `snep-${Date.now()}.${extension}`, {
      type: item.type,
    });
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      try {
        await navigator.share({ files: [file] });
        return;
      } catch (error) {
        if (error.name === "AbortError") return;
      }
    }
    const link = document.createElement("a");
    link.href = mediaUrl;
    link.download = file.name;
    link.click();
  }

  onDestroy(() => {
    if (mediaUrl) URL.revokeObjectURL(mediaUrl);
  });
</script>

<LayeredView {visible} on:close={close}>
  <ViewHeader on:close={close} popWhenClose={false}>
    Sent to {item?.recipients?.join(", ") || "Unknown"}
  </ViewHeader>

  <div class="media-container">
    {#if item}
      {#if item.type.includes("video")}
        <video src={mediaUrl} controls autoplay loop playsinline></video>
      {:else}
        <img src={mediaUrl} alt="Recently sent item" on:click={shareOrSave} />
      {/if}
      <button class="share-button" on:click={shareOrSave}>Share / Save</button>
    {/if}
  </div>
</LayeredView>

<style>
  .media-container {
    width: 100%;
    background: #000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 50vh;
  }

  .media-container img {
    cursor: pointer;
  }

  .share-button {
    margin: 12px 0;
    padding: 8px 24px;
    border: none;
    border-radius: 20px;
    background: #fff;
    color: #000;
    font-size: 1em;
    cursor: pointer;
  }

  .media-container img,
  .media-container video {
    max-width: 100%;
    max-height: 70vh;
    object-fit: contain;
  }
</style>
